import { withInterceptors } from '@angular/common/http';

import { acceptLanguageInterceptor } from './accept-language/accept-language';
import { csrfInterceptor } from './csrf/csrf';
import { oauthInterceptor } from './oauth/oauth';
import { serviceUnavailableInterceptor } from './service-unavailable/service-unavailable';
import { versionInterceptor } from './version/version';

export function provideInterceptors() {
    return withInterceptors([
        oauthInterceptor,
        acceptLanguageInterceptor,
        versionInterceptor,
        serviceUnavailableInterceptor,
        csrfInterceptor,
    ]);
}
